var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},_vm._l((_vm.langs),function(lang){return _c('a',{staticClass:"tabs__link",class:{'tabs__link--active': lang === _vm.current},on:{"click":function($event){return _vm.select(lang)}}},[_vm._v(_vm._s(lang))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }